import { RootState } from '../../../../redux/root-reducer';
import { IPaginationMeta, MODIFIER_GROUP_ACTION_TYPE, ModifierGroup, ModifierGroupActions } from './modifier-group-type';

export enum MODIFIER_GROUP_KEY {
  MODIFIER_GROUPS = 'MODIFIER_GROUPS',
  META = 'META',
  IS_DELETE_SUCCESS = 'IS_DELETE_SUCCESS',
  ALL_MODIFIER_GROUPS = 'ALL_MODIFIER_GROUPS',
  IS_FORM_SUCCESS = 'IS_FORM_SUCCESS',
  TOTAL_GROUPS = 'TOTAL_GROUPS'
}

export type ModifierGroupState = {
  [MODIFIER_GROUP_KEY.MODIFIER_GROUPS]?: ModifierGroup[];
  [MODIFIER_GROUP_KEY.META]?: IPaginationMeta;
  [MODIFIER_GROUP_KEY.IS_DELETE_SUCCESS]?: boolean;
  [MODIFIER_GROUP_KEY.ALL_MODIFIER_GROUPS]?: ModifierGroup[];
  [MODIFIER_GROUP_KEY.IS_FORM_SUCCESS]?: boolean;
  [MODIFIER_GROUP_KEY.TOTAL_GROUPS]?: number;
};

const initialState: ModifierGroupState = {
  [MODIFIER_GROUP_KEY.MODIFIER_GROUPS]: [],
  [MODIFIER_GROUP_KEY.META]: undefined,
  [MODIFIER_GROUP_KEY.IS_DELETE_SUCCESS]: false,
  [MODIFIER_GROUP_KEY.ALL_MODIFIER_GROUPS]: undefined,
  [MODIFIER_GROUP_KEY.IS_FORM_SUCCESS]: false,
  [MODIFIER_GROUP_KEY.TOTAL_GROUPS]: 0,
};

export const modifierGroupReducers = (state = initialState, action: ModifierGroupActions) => {
  switch (action.type) {
    case MODIFIER_GROUP_ACTION_TYPE.SET_MODIFIER_GROUP_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
};

export const modifierGroupStateSelector = <T extends MODIFIER_GROUP_KEY>(key: T) => (state: RootState): ModifierGroupState[T] =>
  state.modifierGroup[key];
